import { render, staticRenderFns } from "./biblioteca.vue?vue&type=template&id=8a2653c6"
import script from "./biblioteca.vue?vue&type=script&lang=js"
export * from "./biblioteca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports